import { Component, Input } from '@angular/core';
import { state, trigger, style, transition, animate } from '@angular/animations';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-custom-toastr',
    templateUrl: './custom-toastr.component.html',
    styleUrls: ['./custom-toastr.component.scss'],
    animations: [
        trigger('flyInOut', [
            state('inactive', style({ top: 0 })),
            state('active', style({ top: 40 })),
            state('removed', style({ top: 0, opacity: 0 })),
            transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
            transition('active => removed', animate('{{ easeTime }}ms {{ easing }}')),
        ]),
    ],
    preserveWhitespaces: false,
    standalone: false
})
export class CustomToastrComponent extends Toast {

  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage) {
    super(toastrService, toastPackage);
  }

  progress = 100;
  private interval: any;
  private readonly duration = 10000;
  copied = false;
  environment?: string;

  @Input() type: 'error' | 'success' = 'success';

  ngOnInit(): void {
    const step = 100 / (this.duration / 100);
    this.interval = setInterval(() => {
      this.progress -= step;
      if (this.progress <= 0) {
        clearInterval(this.interval);
      }
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  copyMessage(event: MouseEvent): void {
    event.stopPropagation();
    const fullText = `${this.title}\n${this.message}`;
    navigator.clipboard.writeText(fullText).then(() => {
      this.copied = true;
      setTimeout(() => {
      this.copied = false;
    }, 800);
    });
  }

  closeToast(): void {
    clearInterval(this.interval);
    this.progress = 0;
  }
  
}